import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { popupcontext } from "../../context/Popupscontext";
import UsersHead from "./UsersParts/UsersHead";
import { useDispatch, useSelector } from "react-redux";
import { setUsers } from "../../Redux/service/Users/UsersSlice";
import Loader from "../Helpers/Loader/Loader";
import UsersForm from "./UsersForm/UsersForm";
import { filtrationcontext } from "../../context/Filtercontext";
import { toast } from "react-toastify";
import trans from "../../utils";
import Actions from "../antd/Table/Actions";
import AntdTable from "../antd/Table/Table";
import { Tag } from "antd";
import Link from "../Helpers/Table/Table Actions/Link";
import usePermission from "../../hooks/usePermission";
import { useGetAllUsersQuery } from "../../Redux/service/Users/AuthUsers";
import AES from "crypto-js/aes";
import CryptoJs from "crypto-js";
export default function Users() {
	const [currentPage, setCurrentPage] = useState(1);
	const { setEdited, deleteItem, setDeleteItem } = useContext(popupcontext);
	const { create, edit, delete: canDelete } = usePermission("SETUPUSERROLES");
	const inf = useSelector((state) => state.users.user);

	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});

	const dispatch = useDispatch();
	let {
		data: AllUsers,
		isLoading,
		isError,
		refetch,
		error,
	} = useGetAllUsersQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
		},
		{
			skip: !currentPage || !limit,
			refetchOnMountOrArgChange: true,
		},
	);
	console.log("Error", error);
	useEffect(() => {
		if (AllUsers?.data) dispatch(setUsers(AllUsers?.data));
	});

	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);

	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);

	const handleSuccess = (newUser) => {
		if (newUser) {
			setEdited(true);
			refetch();
		}
	};
	useEffect(() => {
		async function fetchdata() {
			if (deleteItem.condition === true && deleteItem.value === "users") {
				await refetch();
				setDeleteItem({ condition: null, value: null });
			}
		}
		fetchdata();
	}, [deleteItem.condition, deleteItem.value, refetch, setDeleteItem]);

	if (isError)
		return toast.error(trans(error?.data?.message || "Please try again"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});

	const getRole = (user) => {
		if (
			user?.administrator === false &&
			user?.deviceReadonly === false &&
			(user?.userLimit > 0 || user?.userLimit === -1)
		) {
			return trans("Manager");
		} else if (user?.deviceReadonly) {
			return trans("Fleet Operator");
		} else if (user?.readonly) {
			return trans("Fleet Observer");
		} else if (user?.userLimit === 0 && user?.deviceLimit === 0) {
			return trans("Fleet Observer");
		} else if (user?.administrator === true) {
			return trans("Admin");
		} else {
			return "- - - - -";
		}
	};

	const getType = (user) => {
		if (user.deviceReadonly) return "Fleet Operator";
		if (user.readonly) return "Fleet Observer";
		if (user.userLimit === 0 && user.deviceLimit === 0) return "Fleet Observer";
		return "- - - - -";
	};

	const checkExpire = (expirationTime) => {
		return Date.now() <= new Date(expirationTime).getTime();
	};

	const usersColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			sorter: true,
			fixed: "left",
			key: "name",
			render: (name) => <span>{name}</span>,
		},
		{
			title: trans("role"),
			key: "role",
			render: (_, record) => (
				<Tag color="blue">{record?.role?.name || "-"}</Tag>
			),
		},
		/*{
      title: trans("Type"),
      key: "type",
      render: (_, record) => <span>{getType(record)}</span>,
    },*/
		{
			title: trans("Status"),
			key: "status",
			sorter: true,
			dataIndex: "status",
			render: (_, record) => {
				const isActive = checkExpire(record.expirationTime);
				return (
					<Tag color={isActive ? "green" : "red"}>
						{isActive ? trans("Active") : trans("Expired")}
					</Tag>
				);
			},
		},
		{
			title: trans("Phone Number"),
			sorter: true,
			dataIndex: "phone",
			key: "phone",
			render: (phone) => <span>{phone || "- - - - -"}</span>,
		},
		{
			title: trans("Email"),
			dataIndex: "email",
			sorter: true,
			key: "email",
			render: (email) => (
				<span>
					{email ? email.replace("@gmail.com", "\n@gmail.com") : "- - - - -"}
				</span>
			),
		},
		{
			title: trans("Actions"),
			key: "actions",
			render: (_, record) => (
				<Actions
					userId={record.id}
					name={record.name}
					login={true}
					type="link"
					role={getType(record)}
					expired={!checkExpire(record.expirationTime)}
					canAddTask={inf?.administrator}
					canEdit={inf?.administrator}
					canDelete={inf?.administrator}
				/>
			),
		},
	];

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};

	return (
		<div className="users">
			<Helmet>
				<title>Users</title>
				<meta name="description" content="Users" />
			</Helmet>
			{/* <SecondHeader
				title={trans("users")}
				add={trans("Add new user")}
				onClick={() => handleShow("addForm")}
			/> */}
			<UsersHead />
			{isLoading ? (
				<>
					<div className="loader-container loader-table">
						<Loader />
					</div>
				</>
			) : (
				<>
					<div className="bg-white-rounded-top table-parent">
						<AntdTable
							columns={usersColumns}
							dataSource={AllUsers?.data || []}
							loading={isLoading}
							pageSize={limit}
							totalItems={AllUsers?.totalCount || 0} // Total count for pagination
							currentPage={currentPage}
							onPageChange={(page) => setCurrentPage(page)}
							onLimitChange={(newLimit) => {
								setLimit(newLimit);
								setCurrentPage(1);
							}}
							onTableChange={handleTableChange}
						/>
					</div>
				</>
			)}
			<Link />
			<UsersForm onSuccess={handleSuccess} />
		</div>
	);
}
